import Link from '@jetbrains/ring-ui/dist/link/link'
import { useIsMountedRef } from '@qodana/blocks/lib/hooks'
import { useState } from 'react'
import { useTracking } from 'react-tracking'

import { useLocationStateSaver } from '../../../hooks/urlStateParam'
import { authorize } from '../../../services/authorization'
import { AuthorizationEventGroup } from '../../../tracking/groups/authorization'
import { Error } from '../Error/Error'

export const UnauthenticatedError = () => {
	const getSerializedState = useLocationStateSaver()
	const { trackEvent } = useTracking()
	const isMountedRef = useIsMountedRef()

	const [loginInProgress, setLoginInProgress] = useState(false)

	const handleLoginClick = () => {
		setLoginInProgress(true)
		trackEvent(AuthorizationEventGroup.events.start())
		authorize(getSerializedState()).finally(() => {
			if (!isMountedRef.current) {
				return
			}
			setLoginInProgress(false)
		})
	}

	return (
		<Error
			title={'🙄 Seems like you’re not logged in'}
			content={
				<>
					Please{' '}
					<Link disabled={loginInProgress} onClick={handleLoginClick}>
						login
					</Link>{' '}
					to continue with Qodana
				</>
			}
		/>
	)
}
